import { CartItem } from 'components/cartItem';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import './CartItemsMobile.css';
import { FaArrowDown } from 'react-icons/fa';
import { setCartMobileOpen } from 'features/cart/cartSlice';

const CartItemsMobile = ({ hasCartExtras, extraClass }) => {
    const Lang = useSelector((state) => state.miniBookingWidget?.data?.Lang);
    const items = useSelector((state) => state.cart?.cartItems);
    const currency = useSelector((state) => state.user?.currency);
    const finalPrices = useSelector((state) => state.cart?.finalPrices);
    const firstIncompleteIndex = items.findIndex((item) => !item.isCompleted);
    const currentStep = useSelector((state) => state.cart?.currentStep);
    const dispatch = useDispatch();
    const isCartMobileOpen = useSelector(
        (state) => state.cart?.isCartMobileOpen
    );
    const onClick = (open) => {
        dispatch(setCartMobileOpen(open));
    };
    return (
        <div className="ab-cart-mobile-items-outer-wrapper">
            <div
                className={`ab-cart-mobile-items ab-mobile-cart-button-top`}
                onClick={() => onClick(!isCartMobileOpen)}
            >
                <div>{Lang?.yourStaySummary}</div>
                <div>
                    <FaArrowDown />
                </div>
            </div>
            <div className="ab-cart-mobile-items-inner-wrapper">
                <div className={`ab-cart-side-wrapper ${extraClass}`}>
                    {items?.map((item, index) => {
                        let selected = index === firstIncompleteIndex;
                        if (
                            (currentStep === 2 || currentStep === 3) &&
                            index === 0
                        ) {
                            selected = true;
                        }
                        return (
                            <CartItem
                                key={index}
                                item={item}
                                count={+index + 1}
                                selected={selected}
                                hasCartExtras={hasCartExtras}
                            />
                        );
                    })}
                    {(currentStep === 2 || currentStep === 3) && (
                        <div className="ab-sidebar_total">
                            <table>
                                <tbody>
                                    <tr valign="top">
                                        <td style={{ width: '50%' }}>
                                            {Lang?.total}
                                        </td>
                                        <td
                                            className="ab-js-pricetag"
                                            style={{ width: '50%' }}
                                        >
                                            <p>
                                                {currency} &nbsp;
                                                {finalPrices?.totalPayment}
                                                <span>
                                                    {finalPrices?.cartPolicy}
                                                </span>
                                            </p>
                                        </td>
                                    </tr>

                                    {/* {finalPrices?.totalPayment !==
                                        finalPrices?.paymentAmount && (
                                        <tr valign="top">
                                            <td style={{ width: '50%' }}>
                                                {Lang?.paymentAmount}
                                            </td>
                                            <td
                                                className="ab-js-pricetag"
                                                style={{ width: '50%' }}
                                            >
                                                <p>
                                                    {currency} &nbsp;
                                                    {finalPrices?.paymentAmount}
                                                </p>
                                            </td>
                                        </tr>
                                    )} */}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

CartItemsMobile.propTypes = {
    hasCartExtras: PropTypes.bool,
    extraClass: PropTypes.string,
};

export default CartItemsMobile;
